class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
      //document.querySelector('#collection-grid').classList.remove('open-filter','open-sort');
      document.querySelector('#collection-grid').classList.remove('open-sort');
      typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function' && infinitescroll?.scolljs()
    }, 500); 
      //this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));      
        this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));        
      const applyfilter = this.querySelector('.apply-filter');
      if (applyfilter) applyfilter.addEventListener('click', this.debouncedOnSubmit.bind(this));    
      const filterbtn = this.querySelector('.filter-button');
      const sortbtn = this.querySelector('.sort-button');
      const showbtn = this.querySelector('.show-button');

      const announcementBar = document.querySelector('.annoucement_bar');
      const sectionHeader = document.querySelector('.section-header');
      const navigationCollection = document.querySelector('.navigation_collection');
      const nameCountDv = document.querySelector('.name_count_dv');
      const collectionFilterBar = document.querySelector('.collection_filter_bar');
      const filterWrap = document.querySelector('.filter-wrap');

      if (filterbtn) filterbtn.addEventListener('click',function(e){
      document.querySelector('#collection-grid').classList.toggle('open-filter');
      document.querySelector('body').classList.toggle('open_filter');
      document.querySelector('#collection-grid').classList.remove('open-sort');
      document.querySelector('body').classList.remove('open_sort', 'open-drawer', 'open-menu','open-search');
      if (window.innerWidth > 767) {
        const getVisibleHeight = (element) => {
          if (!element) return 0;
          const rect = element.getBoundingClientRect();
          return Math.max(0, rect.bottom - Math.max(0, rect.top));
        };
  
        const x = getVisibleHeight(announcementBar) +
                  getVisibleHeight(sectionHeader) +
                  getVisibleHeight(navigationCollection) +
                  getVisibleHeight(nameCountDv) +
                  getVisibleHeight(collectionFilterBar);
  
        // filterWrap.style.height = `calc(100vh - ${x}px)`;
      }
  
    });    
      if (sortbtn) sortbtn.addEventListener('click',function(e){
      document.querySelector('#collection-grid').classList.toggle('open-sort');
      document.querySelector('body').classList.toggle('open_sort');
      document.querySelector('#collection-grid').classList.remove('open-filter');
      document.querySelector('body').classList.remove('open_filter', 'open-drawer', 'open-menu','open-search');
       if($(window).width() <= 767){
         $('.sort-box').slideDown();
       } 
    });
    if (showbtn) showbtn.addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('#collection-grid').classList.remove('open-filter');
      document.querySelector('body').classList.remove('open_filter');
    });
      if(document.querySelector('.sort-box')){
      this.querySelector('.sort-box').addEventListener('input', this.debouncedOnSubmit.bind(this));
    }
    }
      static setListeners() {
      const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }
  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
      FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    
  }
  static renderSectionFromFetch(url, event) {
    fetch(url)
    .then(response => response.text())
    .then((responseText) => {
      const html = responseText;
      FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderActiveFilter(html);

      typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function' && infinitescroll?.scolljs()
      if(typeof quickAddButton == 'function'){
      quickAddButton();
    }
      filterprice();

$('.sold_out_images').hide();
      
    });
    }
      static renderSectionFromCache(filterDataUrl, event) {      
      const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderActiveFilter(html);
      if(typeof quickAddButton == 'function'){
      quickAddButton();
    }
    }
    static renderProductGridContainer(html) {
      document.getElementById('collection-grid').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('collection-grid').innerHTML;
      // ------------------------------------------------------------------------------------------------------------------
      if(document.querySelector('.quick-size-filter') && new DOMParser().parseFromString(html, 'text/html').querySelector('.quick-size-filter')){
        document.querySelector('.quick-size-filter').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.quick-size-filter').innerHTML;
      }
      const slider = document.querySelector('.quick-size-filter ul');
      if (slider) {
        let isDown = false;
        let startX;
        let scrollLeft;
        slider.addEventListener('mousedown', (e) => {
          isDown = true;
          slider.classList.add('active'); 
          startX = e.pageX - slider.offsetLeft;
          scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener('mouseleave', () => {
          isDown = false;
          slider.classList.remove('active');
        });
        slider.addEventListener('mouseup', () => {
          isDown = false;
          slider.classList.remove('active');
        });
        slider.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - slider.offsetLeft;
          const walk = (x - startX); 
          slider.scrollLeft = scrollLeft - walk;
        });
      }
      // ------------------------------------------------------------------------------------------------------------------
      let count = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid').getAttribute('data-count');
      document.querySelector('.filter-total-count').textContent = '('+count+')';
      const countText = count < 2 ? 'piece' : 'pieces';
      document.querySelector('.name_count_dv .span_pro').textContent = `${count} ${countText}`;
    }
    static renderActiveFilter(html) {      
      document.querySelector('.active-facet').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.active-facet').innerHTML;
    }
    static renderFilters(html, event) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const facetDetailsElements =
        parsedHTML.querySelectorAll('.filter-index');
      const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.filter-index') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
          const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    facetsToRender.forEach((element) => {
      document.querySelector(`.filter-index[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });
  }
  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }
  static getSections() {
    return [
      {
        section: document.getElementById('collection-grid').dataset.id,
      }
    ]
  }
  onSubmitHandler(event) {  
    // const  filterCheck=(params)=> {
    //   return params.match(/filter/g).length
    // }
    // event.preventDefault();
    // const formData = new FormData(event.target.closest('form'));
    // let searchParams = new URLSearchParams(formData).toString();
    // const result = filterCheck(searchParams);
    // if(!(searchParams.includes("availability"))){
    //    searchParams = searchParams + "&filter.v.availability=1";
    //   // console.log("it doesnt includes", result);
    //   console.log("doesn't include",searchParams, result);
    // }else if (result <= 3 && searchParams.includes("availability")){
    //   searchParams = searchParams.replace('&filter.v.availability=1', " ");
    //   console.log(searchParams);
    //   console.log("less than 3 & does include", result) 
    // }
    // FacetFiltersForm.renderPage(searchParams, event); 

    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);

    const priceLeft = document.querySelector('.price-left');
    const priceRight = document.querySelector('.price-right');
    if (priceLeft && priceRight) {
      if (priceLeft.value === priceLeft.min && priceRight.value === priceRight.max) {
        searchParams.delete('filter.v.price.gte');
        searchParams.delete('filter.v.price.lte');
      }
    }
    if (searchParams.has('filter.v.option.size')) {
      searchParams.set('filter.v.m.online.available', '1');
    } else {
      searchParams.delete('filter.v.m.online.available');
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    
console.log("searchParams", searchParams.toString());
    const existingParams = new URLSearchParams(window.location.search);
    const hasASParam = [...existingParams.keys()].some(k => k === 'view' && existingParams.get(k).startsWith('as'));
    if(hasASParam){
      existingParams.forEach((val, key) => {
        if(key === 'view' && val.startsWith('as') && !searchParams.has(key)){
          searchParams.append(key, val);
        }
      });
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);

    // activefilterscls();

    $('.sorted_val').text($('.filter-sort input[type="radio"]:checked').data('name'));

      if ($(event.target).closest('.filter-sort').length > 0) {
          if ($(window).width() <= 767) {
          $('body').removeClass('open_sort');
          }
      }
    
    document.querySelectorAll('.filter_drawer').forEach((allFilter) => {
      let checkVal = 0;
      allFilter.querySelectorAll('li').forEach((checkedFilter) => {
        checkVal = checkVal + checkedFilter.querySelector('input').checked;
      })
      if(checkVal > 0 && allFilter.closest('.facet-list').querySelector('h4')){
        if(allFilter.closest('.facet-list').querySelector('.filterCount')){
          allFilter.closest('.facet-list').querySelector('.filterCount').setAttribute('data-count',checkVal);
          allFilter.closest('.facet-list').querySelector('.filterCount').textContent = ' ('+checkVal+')';
        }
      }else{
        if(allFilter.closest('.facet-list').querySelector('.filterCount')){
          allFilter.closest('.facet-list').querySelector('.filterCount').setAttribute('data-count','0');
          allFilter.closest('.facet-list').querySelector('.filterCount').textContent = ' (0)';
        }
      }
    });
    
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

document.addEventListener('click', function(event) {
  if (event.target.closest('.active-filters__remove-filter')) {
    event.preventDefault();
    
    const filterLink = event.target.closest('.active-filters__remove-filter');
    const href = filterLink.getAttribute('href');
    
    if (href) {
      // Parse the URL to get search params
      const url = new URL(href, window.location.origin);
      const searchParams = new URLSearchParams(url.search);
      
      // Check if only availability filter remains
      const filterKeys = [...searchParams.keys()].filter(key => key.startsWith('filter.'));
      
      if (filterKeys.length === 1 && searchParams.has('filter.v.m.online.available')) {
        // Only availability filter remains, remove it
        searchParams.delete('filter.v.m.online.available');
      }
      
      // Navigate to the new URL
      const newUrl = searchParams.toString() ? 
        `${window.location.pathname}?${searchParams.toString()}` : 
        window.location.pathname;
      
      window.location.href = newUrl;
    }
  }
});

function filterprice(){
  var inputLeft = document.querySelector(".price-left");
  var inputRight = document.querySelector(".price-right");
  var amountLeft = document.querySelector(".amount-left .amount-percentage");
  var amountRight = document.querySelector(".amount-right .amount-percentage");
  var thumbLeft = document.querySelector(".price-slider > .thumb.left");
  var thumbRight = document.querySelector(".price-slider > .thumb.right");
  var range = document.querySelector(".price-slider > .range");
  function setLeftValue() {
    if(inputLeft != null){
      var _this = inputLeft,
          min = parseInt(_this.min),
          max = parseInt(_this.max);
      _this.value = Math.min(parseInt(_this.value), parseInt(inputRight.value) - 1);
      var percent = ((_this.value - min) / (max - min)) * 100;
      thumbLeft.style.left = percent + "%";
      amountLeft.innerHTML = _this.value;
      range.style.left = percent + "%";
    }
  }
  setLeftValue();
  function setRightValue() {
    if(inputRight != null){
      var _this = inputRight,
          min = parseInt(_this.min),
          max = parseInt(_this.max);
      _this.value = Math.max(parseInt(_this.value), parseInt(inputLeft.value) + 1);
      var percent = ((_this.value - min) / (max - min)) * 100;
      thumbRight.style.right = (100 - percent) + "%";
      amountRight.innerHTML = _this.value;
      range.style.right = (100 - percent) + "%";
      _this.style.zIndex  = 3;
    }
  }
  setRightValue();
  if(inputLeft != null) inputLeft.addEventListener("input", setLeftValue);
  if(inputRight != null) inputRight.addEventListener("input", setRightValue);
  //$('.sold_out_images').hide();
}
if(document.querySelector('.range-wrap')){
  filterprice();  
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fnBrowserDetect(){
  let userAgent = navigator.userAgent;
  let browserName;
  if(userAgent.match(/chrome|chromium|crios/i)){
    browserName = "chrome";
  }else if(userAgent.match(/firefox|fxios/i)){
    browserName = "firefox";
  }  else if(userAgent.match(/safari/i)){
    browserName = "safari";
  }else if(userAgent.match(/opr\//i)){
    browserName = "opera";
  } else if(userAgent.match(/edg/i)){
    browserName = "edge";
  }else{
    browserName="no-browser";
  }
  document.getElementById('MainContent').classList.add(browserName);
  $('.sorted_val').text($('.filter-sort input[type="radio"]:checked').data('name'));
}
fnBrowserDetect()
$(document).on('click', '.facet-list h4', function(){
  $(this).toggleClass('active');
  $(this).parents('.facet-list').find('.filter_drawer').slideToggle(200);
})
$(document).on('click', '.btn_wrapper .sort-button', function(){
  $('.filter_wrapper_div .sort-button').click();
});
$(document).on('click', '.btn_wrapper .filter-button', function(){
  $('.filter_wrapper_div .filter-button').click();
});
$('body').on('click',function(e){
  var container = $(".filterwrap, .filter-button, .sort-button");
  if (!container.is(e.target) && container.has(e.target).length === 0){
    $('#collection-grid').removeClass('open-filter');
    $('body').removeClass('open_filter');
    $('#collection-grid').removeClass('open-sort');
    $('body').removeClass('open_sort');
  }
});
$(document).on('click','.close_filter_btn', function (){
  $('#collection-grid').removeClass('open-filter');
    $('body').removeClass('open_filter');
})

